import { Wrapper } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const QuickActionChip: FunctionComponent<Props> = ({
    className = '',
    icon,
    isLoading = false,
    label,
    onClick,
    testId = TEST_ID
}) => (
    <button
        className={`${styles.quickActionChip} ${className}`}
        data-testid={testId}
        disabled={isLoading}
        onClick={onClick}
        type='button'>
        <Wrapper className={styles.iconSlot}>{icon}</Wrapper>

        <Wrapper className={styles.label}>{label}</Wrapper>
    </button>
);

export default QuickActionChip;
